import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Breadcrumb } from "../../../molecules/Breadcrumb";
import { titles } from "../../../constants/titles";
import {
  BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE,
  bulkUpsertStudents,
  clearErrorMessage,
  Context,
  fetchClasses,
  studentsPath,
  clearSuccessMessage,
} from "../../../managerStore";
import { BulkStudentForm } from "../../../templates/manager/BulkStudentForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { IStudentForRegister } from "../../../state";

export const BulkRegisterStudents = () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const { currentYear } = useCurrentYear();
  const history = useHistory();
  const bulkRegisterStudentsFunc = useCallback(
    (students: IStudentForRegister[]) => {
      dispatch(peep(bulkUpsertStudents(students)));
    },
    [dispatch, peep],
  );

  useEffect(() => {
    if (state.success_message === BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(studentsPath);
    }
  }, [history, dispatch, state.success_message]);

  useEffect(() => {
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[
          {
            title:
              state.manager.school?.use_case === "cram_school"
                ? titles.cramSchoolStudents
                : titles.students,
            to: studentsPath,
          },
        ]}
        currentTitle={titles.BulkRegisterStudents}
      />
      <BulkStudentForm
        title={titles.BulkRegisterStudents}
        classes={state.classes}
        error={state.error}
        isNextYear={false}
        save={bulkRegisterStudentsFunc}
        calling={calling}
        school={state.manager.school!}
      />
    </div>
  );
};

export default BulkRegisterStudents;
